import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-center"},[_c(VAvatar,{staticClass:"mx-auto",attrs:{"size":"72"}},[_c(VImg,{attrs:{"src":_vm.storeIcon}})],1),_c('div',{staticClass:"title "},[_vm._v("\n        "+_vm._s(_vm.store.name)+"\n    ")]),_c('div',{staticClass:"grey--text body-2"},[_vm._v("\n        "+_vm._s(_vm.store.address)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }